import React, {useState, useEffect} from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useParams,
  useRouteMatch,
  useHistory
} from "react-router-dom";
import {useFirebase, useFirestore, useFirestoreConnect} from "react-redux-firebase";
import {useDispatch, useSelector} from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import SplashScreen from '../../ui/SplashScreen'

import '../../../styles/Plants.css'
import {showSuccessSnackbar} from "../../utils/actions/SnackbarActions";


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    alignSelf: 'flex-end',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 40,
    paddingBottom: 40
  },

}));

const PlantEventActive = (props) => {

  let routeParams = useParams();
  let history = useHistory();
  const firestore = useFirestore();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { uid } = useSelector((state) => state.firebase.auth);

  const [eventItem, setEventItem] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleActiveChange = () => {
    setLoading(true)
    firestore
      .collection('plants')
      .doc(props.plantItem.plantID)
      .collection('plantItems')
      .doc(eventItem.itemID)
      .update({
        active: !eventItem.active,
        updatedAt: Date.now(),
        updatedBy: uid,
      }).then(() =>{
      setLoading(false)
      dispatch(showSuccessSnackbar(props.plantItem.plantName + ' uppdaterades!'));
    }).catch((err) => {
      console.log(err)
      setLoading(false)
      dispatch(showSuccessSnackbar("Något gick fel. Var god försök igen!"));
    });
  };

  useEffect(() => {
    if (props.eventItem) {
      setEventItem(props.eventItem)
    } else {
      setEventItem(null)
    }
  }, [props]);

  return (
    eventItem ? (
      <div className={classes.root}>
        {loading ? (
          <SplashScreen/>
        ) : (
          eventItem.active ? (
            <Button onClick={handleActiveChange} color="primary">
              Avaktivera
            </Button>
          ) : (
            <Button onClick={handleActiveChange} color="primary">
              Aktivera
            </Button>
          )
        )}
      </div>
    ) : (
      null
    )
  );
};
export default PlantEventActive;
